import { API_AGENT_PATH, API_HOST_NAME } from '../../env.js';
import { GET_REQUEST } from '@helpers/request.js';

const AGENT_ROOT = API_HOST_NAME + API_AGENT_PATH;
const structurePaths = {
  getProvince: AGENT_ROOT + '/get-province',
  getDistrict: AGENT_ROOT + '/get-district',
  getWard: AGENT_ROOT + '/get-ward',
};
export const getProvinceDataService = (payload) => {
  return GET_REQUEST(structurePaths.getProvince, payload);
};

export const getDistrictDataService = (payload) => {
  return GET_REQUEST(structurePaths.getDistrict, payload);
};

export const getWardDataService = (payload) => {
  return GET_REQUEST(structurePaths.getWard, payload);
};
